var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contract-requests container container_30" },
    [
      _c("searcher", { on: { "compose-filters": _vm.loadFilteredContracts } }),
      _vm._v(" "),
      _c(
        "md-table",
        { staticClass: "contract-requests__table" },
        [
          _vm.list.length
            ? [
                _c(
                  "md-table-row",
                  { staticClass: "contract-requests_row" },
                  [
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.cont_counterparty()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [_vm._v(_vm._s(_vm.i18n.lbl_type()))]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.com_state_as_status()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.cont_contract_number()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.lbl_start_date()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.lbl_end_date()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head")
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.list, function(item, i) {
                  return [
                    item.state !== _vm.REQUEST_STATES_STR.approved
                      ? _c(
                          "md-table-row",
                          { key: i, staticClass: "contract-requests__row" },
                          [
                            _c(
                              "md-table-cell",
                              {
                                staticClass:
                                  "contract-requests__table-cell counterparty-cell"
                              },
                              [
                                _c("company-name-getter", {
                                  attrs: { id: item.requestor }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "md-table-cell",
                              {
                                staticClass:
                                  "contract-requests__table-cell counterparty-cell"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.getContractType(item.requestor))
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "md-table-cell",
                              {
                                staticClass:
                                  "contract-requests__table-cell contract-request-state-cell"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item.state ===
                                      _vm.REQUEST_STATES_STR.permanentlyRejected
                                      ? _vm.REQUEST_STATES_STR.rejected
                                      : item.state
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "md-table-cell",
                              {
                                staticClass:
                                  "contract-requests__table-cell contract-number-cell"
                              },
                              [_vm._v(_vm._s(item.contractNumber))]
                            ),
                            _vm._v(" "),
                            _c(
                              "md-table-cell",
                              { staticClass: "contract-requests__table-cell" },
                              [_vm._v(_vm._s(_vm.i18n.d(item.startTime)))]
                            ),
                            _vm._v(" "),
                            _c(
                              "md-table-cell",
                              { staticClass: "contract-requests__table-cell" },
                              [_vm._v(_vm._s(_vm.i18n.d(item.endTime)))]
                            ),
                            _vm._v(" "),
                            _c(
                              "md-table-cell",
                              { staticClass: "contract-requests__table-cell" },
                              [
                                _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "contract-requests__view-details-btn md-icon-button",
                                    on: {
                                      click: function($event) {
                                        return _vm.openDetails(item.id)
                                      }
                                    }
                                  },
                                  [
                                    _c("md-icon", [
                                      _vm._v("keyboard_arrow_right")
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }),
                _vm._v(" "),
                !_vm.isLoaded
                  ? _c(
                      "md-table-row",
                      [
                        _c("md-table-cell", { attrs: { colspan: "7" } }, [
                          _c(
                            "div",
                            { staticClass: "contract-requests__btn-outer" },
                            [
                              _c(
                                "md-button",
                                {
                                  staticClass: "md-primary",
                                  attrs: { disabled: _vm.isLoading },
                                  on: { click: _vm.more }
                                },
                                [_vm._v(_vm._s(_vm.i18n.lbl_view_more()))]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : [
                _c(
                  "div",
                  { staticClass: "contract-requests__no-contracts" },
                  [
                    _c("md-icon", { staticClass: "md-size-4x" }, [
                      _vm._v("trending_up")
                    ]),
                    _vm._v(" "),
                    _c("h2", [
                      _vm._v(_vm._s(_vm.i18n.cont_no_contract_requests()))
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.i18n.cont_no_contract_requests_desc()))
                    ])
                  ],
                  1
                )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9144c4a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9144c4a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/contracts/index/requests/Contracts.RequestsList.vue
// module id = zVsh
// module chunks = 1